<section class="cloud-infrastructure-hero">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="hero-content">
                    <span class="hero-badge">Join Our Team</span>
                    <h1 class="hero-title">Build the Future of Cloud Computing</h1>
                    <p class="hero-description">Shape the next generation of cloud infrastructure with cutting-edge NVIDIA GPU technology, AI/ML platforms, and enterprise solutions. Join India's leading cloud infrastructure team and accelerate your career.</p>
                    
                    <div class="career-highlights">
                        <div class="highlight-item">
                            <div class="highlight-number">15+</div>
                            <div class="highlight-label">Open Positions</div>
                        </div>
                        <div class="highlight-item">
                            <div class="highlight-number">500+</div>
                            <div class="highlight-label">Team Members</div>
                        </div>
                        <div class="highlight-item">
                            <div class="highlight-number">2</div>
                            <div class="highlight-label">Office Locations</div>
                        </div>
                    </div>
                    
                    <div class="hero-actions">
                        <a class="btn-primary-gradient" href="#job-openings">
                            <i class="bx bx-briefcase"></i>
                            View Open Positions
                        </a>
                        <a class="btn-outline-light" href="mailto:careers@insightfulitservices.com">
                            <i class="bx bx-envelope"></i>
                            Contact HR Team
                        </a>
                    </div>
                    
                    <div class="hero-features">
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Remote Work Available</span>
                        </div>
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Competitive Benefits</span>
                        </div>
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Learning & Development</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="hero-image">
                    <div class="image-decoration">
                        <div class="floating-card card-1">
                            <i class="bx bx-trending-up"></i>
                            <span>Career Growth</span>
                        </div>
                        <div class="floating-card card-2">
                            <i class="bx bx-award"></i>
                            <span>Industry Recognition</span>
                        </div>
                        <div class="floating-card card-3">
                            <i class="bx bx-group"></i>
                            <span>Great Team Culture</span>
                        </div>
                    </div>
                    <img src="assets/img/solutions-img.png" alt="Career Opportunities" class="img-fluid main-image">
                </div>
            </div>
        </div>
    </div>
    <div class="hero-background-elements">
        <div class="bg-element element-1"></div>
        <div class="bg-element element-2"></div>
        <div class="bg-element element-3"></div>
    </div>
</section>

<!-- Company Culture Section -->
<section class="company-culture-section ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="culture-content">
                    <span class="section-badge">Why Choose Us</span>
                    <h2>Work with <span class="text-highlight">Industry Leaders</span></h2>
                    <p class="culture-description">At Insightful IT Services, we're building the future of cloud computing and AI/ML platforms. Join our passionate team of innovators, engineers, and cloud experts who are dedicated to delivering cutting-edge solutions with NVIDIA GPU technology.</p>
                    
                    <div class="culture-features">
                        <div class="feature-item">
                            <div class="feature-icon">
                                <i class="bx bx-chip"></i>
                            </div>
                            <div class="feature-content">
                                <h4>Innovation First</h4>
                                <p>Work with the latest technologies including NVIDIA H200, H100, and A100 GPUs for AI/ML workloads</p>
                            </div>
                        </div>
                        
                        <div class="feature-item">
                            <div class="feature-icon">
                                <i class="bx bx-trending-up"></i>
                            </div>
                            <div class="feature-content">
                                <h4>Career Growth</h4>
                                <p>Continuous learning opportunities with certification programs and clear career advancement paths</p>
                            </div>
                        </div>
                        
                        <div class="feature-item">
                            <div class="feature-icon">
                                <i class="bx bx-group"></i>
                            </div>
                            <div class="feature-content">
                                <h4>Collaborative Team</h4>
                                <p>Work alongside industry experts in a supportive and inclusive environment across Mumbai and Noida</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="culture-image">
                    <div class="image-wrapper">
                        <img src="assets/img/support-img.png" alt="Team Collaboration" class="img-fluid">
                        
                        <div class="floating-stats">
                            <div class="stat-card card-1">
                                <div class="stat-number">15+</div>
                                <div class="stat-label">Open Roles</div>
                            </div>
                            <div class="stat-card card-2">
                                <div class="stat-number">95%</div>
                                <div class="stat-label">Employee Satisfaction</div>
                            </div>
                            <div class="stat-card card-3">
                                <div class="stat-number">24/7</div>
                                <div class="stat-label">Support Coverage</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Job Openings Section -->
<section class="job-openings-section ptb-100" id="job-openings">
    <div class="container">
        <div class="section-title">
            <span class="section-badge">Open Positions</span>
            <h2>Current <span class="text-highlight">Job Opportunities</span></h2>
            <p>Explore exciting career opportunities and become part of our growing cloud infrastructure team</p>
        </div>

        <div class="row">
            <!-- Cloud Infrastructure Engineer -->
            <div class="col-lg-6 col-md-12 mb-4">
                <div class="job-card featured">
                    <div class="job-header">
                        <div class="job-icon">
                            <i class="bx bx-server"></i>
                        </div>
                        <div class="job-badge">Hot Role</div>
                    </div>
                    <div class="job-content">
                        <h3>Cloud Infrastructure Engineer</h3>
                        <div class="job-meta">
                            <span class="location"><i class="bx bx-map"></i> Mumbai, India</span>
                            <span class="job-type"><i class="bx bx-time"></i> Full-time</span>
                            <span class="experience"><i class="bx bx-user"></i> 3-5 years</span>
                        </div>
                        <p class="job-description">Design and implement scalable cloud infrastructure solutions using cutting-edge NVIDIA GPU technology and AI/ML platforms. Lead digital transformation projects for enterprise clients.</p>
                        <div class="job-skills">
                            <span class="skill-tag">AWS</span>
                            <span class="skill-tag">Kubernetes</span>
                            <span class="skill-tag">NVIDIA GPU</span>
                            <span class="skill-tag">TensorFlow</span>
                            <span class="skill-tag">Docker</span>
                        </div>
                        <div class="job-salary">
                            <span class="salary-range">₹8-15 LPA</span>
                            <span class="salary-note">Based on experience</span>
                        </div>
                    </div>
                    <div class="job-actions">
                        <a href="mailto:careers@insightfulitservices.com?subject=Application for Cloud Infrastructure Engineer" class="btn-apply">Apply Now</a>
                        <a href="javascript:void(0)" class="btn-details">View Details</a>
                    </div>
                </div>
            </div>

            <!-- AI/ML Platform Engineer -->
            <div class="col-lg-6 col-md-12 mb-4">
                <div class="job-card featured">
                    <div class="job-header">
                        <div class="job-icon">
                            <i class="bx bx-chip"></i>
                        </div>
                        <div class="job-badge premium">Premium Role</div>
                    </div>
                    <div class="job-content">
                        <h3>AI/ML Platform Engineer</h3>
                        <div class="job-meta">
                            <span class="location"><i class="bx bx-map"></i> Mumbai, India</span>
                            <span class="job-type"><i class="bx bx-time"></i> Full-time</span>
                            <span class="experience"><i class="bx bx-user"></i> 4-7 years</span>
                        </div>
                        <p class="job-description">Build and optimize our TIR AI/ML Platform using NVIDIA H200/H100 GPUs. Develop machine learning infrastructure for enterprise AI workloads and research projects.</p>
                        <div class="job-skills">
                            <span class="skill-tag">PyTorch</span>
                            <span class="skill-tag">CUDA</span>
                            <span class="skill-tag">NVIDIA H200</span>
                            <span class="skill-tag">MLOps</span>
                            <span class="skill-tag">Python</span>
                        </div>
                        <div class="job-salary">
                            <span class="salary-range">₹12-25 LPA</span>
                            <span class="salary-note">Based on experience</span>
                        </div>
                    </div>
                    <div class="job-actions">
                        <a href="mailto:careers@insightfulitservices.com?subject=Application for AI/ML Platform Engineer" class="btn-apply">Apply Now</a>
                        <a href="javascript:void(0)" class="btn-details">View Details</a>
                    </div>
                </div>
            </div>

            <!-- Senior DevOps Engineer -->
            <div class="col-lg-6 col-md-12 mb-4">
                <div class="job-card">
                    <div class="job-header">
                        <div class="job-icon">
                            <i class="bx bx-cog"></i>
                        </div>
                        <div class="job-badge">DevOps</div>
                    </div>
                    <div class="job-content">
                        <h3>Senior DevOps Engineer</h3>
                        <div class="job-meta">
                            <span class="location"><i class="bx bx-map"></i> Noida, India</span>
                            <span class="job-type"><i class="bx bx-time"></i> Full-time</span>
                            <span class="experience"><i class="bx bx-user"></i> 5+ years</span>
                        </div>
                        <p class="job-description">Lead CI/CD initiatives and automate cloud deployment processes for high-performance computing environments across our Mumbai and Noida data centers.</p>
                        <div class="job-skills">
                            <span class="skill-tag">Docker</span>
                            <span class="skill-tag">Jenkins</span>
                            <span class="skill-tag">Terraform</span>
                            <span class="skill-tag">Ansible</span>
                            <span class="skill-tag">Python</span>
                        </div>
                        <div class="job-salary">
                            <span class="salary-range">₹10-18 LPA</span>
                            <span class="salary-note">Based on experience</span>
                        </div>
                    </div>
                    <div class="job-actions">
                        <a href="mailto:careers@insightfulitservices.com?subject=Application for Senior DevOps Engineer" class="btn-apply">Apply Now</a>
                        <a href="javascript:void(0)" class="btn-details">View Details</a>
                    </div>
                </div>
            </div>

            <!-- Cloud Security Specialist -->
            <div class="col-lg-6 col-md-12 mb-4">
                <div class="job-card">
                    <div class="job-header">
                        <div class="job-icon">
                            <i class="bx bx-shield-check"></i>
                        </div>
                        <div class="job-badge security">Security</div>
                    </div>
                    <div class="job-content">
                        <h3>Cloud Security Specialist</h3>
                        <div class="job-meta">
                            <span class="location"><i class="bx bx-map"></i> Mumbai, India</span>
                            <span class="job-type"><i class="bx bx-time"></i> Full-time</span>
                            <span class="experience"><i class="bx bx-user"></i> 3-6 years</span>
                        </div>
                        <p class="job-description">Ensure security and compliance of cloud infrastructure with focus on data protection, ISO 27001, and SOC 2 Type II requirements.</p>
                        <div class="job-skills">
                            <span class="skill-tag">ISO 27001</span>
                            <span class="skill-tag">SOC 2</span>
                            <span class="skill-tag">GDPR</span>
                            <span class="skill-tag">Cybersecurity</span>
                            <span class="skill-tag">Compliance</span>
                        </div>
                        <div class="job-salary">
                            <span class="salary-range">₹9-16 LPA</span>
                            <span class="salary-note">Based on experience</span>
                        </div>
                    </div>
                    <div class="job-actions">
                        <a href="mailto:careers@insightfulitservices.com?subject=Application for Cloud Security Specialist" class="btn-apply">Apply Now</a>
                        <a href="javascript:void(0)" class="btn-details">View Details</a>
                    </div>
                </div>
            </div>

            <!-- Customer Success Manager -->
            <div class="col-lg-6 col-md-12 mb-4">
                <div class="job-card">
                    <div class="job-header">
                        <div class="job-icon">
                            <i class="bx bx-user-check"></i>
                        </div>
                        <div class="job-badge">Customer Success</div>
                    </div>
                    <div class="job-content">
                        <h3>Customer Success Manager</h3>
                        <div class="job-meta">
                            <span class="location"><i class="bx bx-map"></i> Mumbai, India</span>
                            <span class="job-type"><i class="bx bx-time"></i> Full-time</span>
                            <span class="experience"><i class="bx bx-user"></i> 3-5 years</span>
                        </div>
                        <p class="job-description">Drive customer satisfaction and retention by ensuring clients achieve their cloud transformation goals with our GPU computing solutions.</p>
                        <div class="job-skills">
                            <span class="skill-tag">Account Management</span>
                            <span class="skill-tag">Cloud Technologies</span>
                            <span class="skill-tag">Customer Relations</span>
                            <span class="skill-tag">Technical Support</span>
                        </div>
                        <div class="job-salary">
                            <span class="salary-range">₹7-12 LPA</span>
                            <span class="salary-note">Based on experience</span>
                        </div>
                    </div>
                    <div class="job-actions">
                        <a href="mailto:careers@insightfulitservices.com?subject=Application for Customer Success Manager" class="btn-apply">Apply Now</a>
                        <a href="javascript:void(0)" class="btn-details">View Details</a>
                    </div>
                </div>
            </div>

            <!-- Technical Sales Engineer -->
            <div class="col-lg-6 col-md-12 mb-4">
                <div class="job-card">
                    <div class="job-header">
                        <div class="job-icon">
                            <i class="bx bx-line-chart"></i>
                        </div>
                        <div class="job-badge">Sales</div>
                    </div>
                    <div class="job-content">
                        <h3>Technical Sales Engineer</h3>
                        <div class="job-meta">
                            <span class="location"><i class="bx bx-map"></i> Mumbai, India</span>
                            <span class="job-type"><i class="bx bx-time"></i> Full-time</span>
                            <span class="experience"><i class="bx bx-user"></i> 2-4 years</span>
                        </div>
                        <p class="job-description">Drive revenue growth by identifying opportunities and providing technical expertise to prospective clients interested in GPU cloud solutions.</p>
                        <div class="job-skills">
                            <span class="skill-tag">Sales</span>
                            <span class="skill-tag">Cloud Solutions</span>
                            <span class="skill-tag">B2B</span>
                            <span class="skill-tag">Presentations</span>
                            <span class="skill-tag">CRM</span>
                        </div>
                        <div class="job-salary">
                            <span class="salary-range">₹6-12 LPA</span>
                            <span class="salary-note">+ Performance Incentives</span>
                        </div>
                    </div>
                    <div class="job-actions">
                        <a href="mailto:careers@insightfulitservices.com?subject=Application for Technical Sales Engineer" class="btn-apply">Apply Now</a>
                        <a href="javascript:void(0)" class="btn-details">View Details</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Benefits Section -->
<section class="benefits-section ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="section-badge">Employee Benefits</span>
            <h2>Comprehensive <span class="text-highlight">Benefits Package</span></h2>
            <p>We believe in taking care of our team members with industry-leading benefits and a supportive work environment</p>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="benefit-card">
                    <div class="benefit-icon">
                        <i class="bx bx-health"></i>
                    </div>
                    <div class="benefit-content">
                        <h4>Health & Wellness</h4>
                        <p>Comprehensive health insurance, dental coverage, mental health support, and wellness programs</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4">
                <div class="benefit-card">
                    <div class="benefit-icon">
                        <i class="bx bx-book-open"></i>
                    </div>
                    <div class="benefit-content">
                        <h4>Learning & Development</h4>
                        <p>Annual learning budget, conference attendance, certification programs, and internal training</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4">
                <div class="benefit-card">
                    <div class="benefit-icon">
                        <i class="bx bx-time-five"></i>
                    </div>
                    <div class="benefit-content">
                        <h4>Work-Life Balance</h4>
                        <p>Flexible working hours, remote work options, and generous paid time off policies</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4">
                <div class="benefit-card">
                    <div class="benefit-icon">
                        <i class="bx bx-rupee"></i>
                    </div>
                    <div class="benefit-content">
                        <h4>Financial Benefits</h4>
                        <p>Competitive salary, performance bonuses, equity participation, and retirement planning</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4">
                <div class="benefit-card">
                    <div class="benefit-icon">
                        <i class="bx bx-buildings"></i>
                    </div>
                    <div class="benefit-content">
                        <h4>Modern Workspace</h4>
                        <p>State-of-the-art office facilities, latest technology equipment, and collaborative spaces</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4">
                <div class="benefit-card">
                    <div class="benefit-icon">
                        <i class="bx bx-party"></i>
                    </div>
                    <div class="benefit-content">
                        <h4>Team Events</h4>
                        <p>Regular team building activities, company retreats, and professional networking events</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Application Process Section -->
<section class="application-process-section ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="section-badge">Hiring Process</span>
            <h2>Simple & <span class="text-highlight">Transparent Process</span></h2>
            <p>We've designed an efficient and transparent hiring process to help you showcase your skills and experience</p>
        </div>

        <div class="row">
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="process-step">
                    <div class="step-number">1</div>
                    <div class="step-content">
                        <h4>Application Review</h4>
                        <p>We carefully review your application and resume within 3-5 business days</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 mb-4">
                <div class="process-step">
                    <div class="step-number">2</div>
                    <div class="step-content">
                        <h4>Initial Screening</h4>
                        <p>Phone or video call to discuss your background and interest in the role</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 mb-4">
                <div class="process-step">
                    <div class="step-number">3</div>
                    <div class="step-content">
                        <h4>Technical Interview</h4>
                        <p>Technical assessment and discussion with team members about your expertise</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 mb-4">
                <div class="process-step">
                    <div class="step-number">4</div>
                    <div class="step-content">
                        <h4>Final Interview</h4>
                        <p>Meet with senior leadership and discuss cultural fit and career goals</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Contact HR Section -->
<section class="contact-hr-section ptb-100">
    <div class="container">
        <div class="cta-content-wrapper">
            <div class="row align-items-center">
                <div class="col-lg-8">
                    <div class="hr-contact-content">
                        <h2>Ready to Join Our Team?</h2>
                        <p class="cta-description">Have questions about careers at Insightful IT Services? Our HR team is here to help you understand more about opportunities. Don't see a role that fits? Send us your resume anyway - we're always looking for exceptional talent!</p>
                        
                        <div class="contact-features">
                            <div class="feature-item">
                                <i class="bx bx-envelope"></i>
                                <span>careers@insightfulitservices.com</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-phone"></i>
                                <span>+91 9167663638</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-time"></i>
                                <span>Response within 24 hours</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="cta-actions">
                        <a class="btn-cta-primary" href="mailto:careers@insightfulitservices.com">
                            <i class="bx bx-envelope"></i>
                            <span>Email HR Team</span>
                            <small>Send us your resume</small>
                        </a>
                        <a class="btn-cta-secondary" routerLink="/contact">
                            <i class="bx bx-phone"></i>
                            <span>General Contact</span>
                            <small>Have other questions?</small>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="cta-background-elements">
        <div class="bg-element element-1"></div>
        <div class="bg-element element-2"></div>
        <div class="bg-element element-3"></div>
        <div class="bg-element element-4"></div>
    </div>
</section>